import React from 'react'

import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button'
import { Dropdown } from 'primereact/dropdown'
import { Message } from 'primereact/message'

import '../../css/annual-return-table.css'

import { formatDate } from '../../js/utils'

const AnnualReturnTableFooter = ({ addAnnualReturn, annualReturnYearOptions, newAnnualReturnYear, setNewAnnualReturnYear }) => {
  let annualReturnMessage = annualReturnYearOptions.length > 0 ? 'Please select which year to create an annual return for.' : 'Annual reports can be added from 1 Jan 2019.'
  return (
    <div className="p-helper-clearfix" style={{ width: '100%' }}>
      <div className="p-grid">
        <div className="p-col-12">
          <Message style={{ width: '100%' }} severity="info" text={annualReturnMessage}></Message>
        </div>
        <div className="p-col-12">
          <div className="p-inputgroup">
            <Dropdown value={newAnnualReturnYear || ''}
              className={'app-dropdown'}
              options={annualReturnYearOptions}
              onChange={e => {
                setNewAnnualReturnYear(e.value)
              }}
            />
            {newAnnualReturnYear && <Button icon="pi pi-plus" label="Add Annual Return" onClick={addAnnualReturn} />}
          </div>
        </div>
      </div>
    </div>
  )
}

const StartDateTemplate = rowData => {
  return <span>{formatDate(rowData['StartDate'])}</span>;
}

const EndDateTemplate = rowData => {
  return <span>{formatDate(rowData['EndDate'])}</span>;
}

const AnnualReturnTable = ({ canSave, addAnnualReturn, annualReturns, selectAnnualReturn, selectedAnnualReturn, 
    annualReturnYearOptions, newAnnualReturnYear, setNewAnnualReturnYear, isLobbyistApproved }) => {
  let footer = canSave === true && isLobbyistApproved === true && <AnnualReturnTableFooter addAnnualReturn={addAnnualReturn} annualReturnYearOptions={annualReturnYearOptions}
    newAnnualReturnYear={newAnnualReturnYear} setNewAnnualReturnYear={setNewAnnualReturnYear} />
  return (
    <DataTable value={annualReturns} footer={footer} selectionMode="single" selection={selectedAnnualReturn} responsive={true}
      onSelectionChange={selectAnnualReturn} className={'annual-return-table'}>
      <Column field="TypeDescription" header="Type" />
      <Column field="StartDate" header="Start Date" body={StartDateTemplate} />
      <Column field="EndDate" header="End Date" body={EndDateTemplate} />
      <Column field="StatusDescription" header="Status" />
    </DataTable>
  )
}

export default AnnualReturnTable;


// WEBPACK FOOTER //
// ./src/components/annual-return/annual-return-table.js